import { node } from 'prop-types'
import type { CSSProperties } from 'react'
import { Header } from 'semantic-ui-react'
import ImgTemplate from '../../../../utilites/ImgTemplate'

const imageContainerStyle: CSSProperties = {
  textAlign: 'center',
  marginBottom: '1.2em',
}

function ProjectDescription() {
  return (
    <div className='fade-in'>
      <Header as='h1' style={{ textAlign: 'center' }}>
        Project description
      </Header>

      <div style={{ textAlign: 'justify', marginBottom: '1em' }}>
        The ROSIE project demonstrates the proof of concept for “The European F10.7 and F30 Indexes Monitoring System”
        (EFFIMS), currently implemented as the ROSIE system. The instrument monitors solar radio emission in two
        standard Space weather bands: F10.7 (10.7 cm, 2.8 GHz) and F30 (30 cm, 1 GHz).
      </div>

      <div style={{ textAlign: 'justify', marginBottom: '1em' }}>
        The project is carried out by the Institute of Astronomy, University of Wrocław and ITTI sp. z o.o., and is
        financed from the European Space Agency budget. <strong>Contract No: 4000131342/20/D/CT</strong>.
      </div>

      <div style={imageContainerStyle}>
        <div style={{ maxWidth: '300px', width: '100%', marginInline: 'auto' }}>
          <ImgTemplate srcName='projectdescription/ROSIE_new_logo.png' alt='6 m parabolic antenna' width='100%' />
          <p style={{ fontSize: '0.9em', color: '#555', marginTop: '0.4em', fontStyle: 'italic' }}>Author: ITTI</p>
        </div>
      </div>

      <div style={{ textAlign: 'justify', marginBottom: '1em' }}>
        The main objective is to deliver continuous, calibrated, and low-latency observations of solar radio flux in the
        F10.7 and F30 bands, suitable for operational Space weather services and scientific research. The system targets
        robust round-the-clock operation, standardized data formats, and open programmatic access, enabling rapid
        ingestion by national and European platforms.
      </div>

      <div style={{ textAlign: 'justify' }}>
        The expected end-users include national and European Union institutions involved in Space weather activities,
        government agencies responsible for crisis management, scientific institutions specialising in astronomy,
        geophysics, and related sciences, the military, air traffic control authorities, power transmission operators,
        as well as amateur astronomers, educators, the general public, and students at various levels of education.
      </div>
    </div>
  )
}

ProjectDescription.propTypes = {
  children: node,
}

export default ProjectDescription
